export enum HtmlIds {
  NEIGHBORHOOD_FEATURE_WALK_SCORE = 'walk-score',
  NEIGHBORHOOD_FEATURE_TERRAIN = 'terrain',
  NEIGHBORHOOD_FEATURE_GREENWAYS = 'greenways',
  WELLNESS_PLANS_SECTION = 'plans-section',
  VET_CHAT_WIDGET = 'vet-chat-widget',
}
